import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS, phoneFormatRegex } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputMaskField from '../../../../ui/customInputMask';
const Index = ({ FORM_FIELD_SPECS, selectedSearchType, searchParams, errors, register }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <CardContent className="space-y-2 lg:pr-0" key={`key_${selectedSearchType}`}>
      <div className="flex">
        <InputMaskField
          mask="(999)999-9999"
          items={`${Texts?.phoneNumber}`}
          id={FORM_FIELD_SPECS?.phoneNumber?.id}
          htmlFor={FORM_FIELD_SPECS?.phoneNumber?.id}
          register={register}
          errors={errors}
          label={Texts?.phoneNumber}
          classname="w-full"
          rules={{
            required: Texts?.phoneNumberRequired,
            pattern: {
              value: phoneFormatRegex,
              message: Texts?.phoneNumberInvalidFormat,
            },
          }}
          defaultValue={searchParams?.[FORM_FIELD_SPECS?.phoneNumber?.id]}
          maxLength={FORM_FIELD_SPECS?.phoneNumber?.maxLength}
          hideError
          isNum
        />
        <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
          <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
        </Button>
      </div>
      {errors?.[FORM_FIELD_SPECS?.phoneNumber?.id] && (
        <p className="mt-2 text-sm text-scarletRed">{errors[FORM_FIELD_SPECS?.phoneNumber?.id]?.message}</p>
      )}
    </CardContent>
  );
};

export default Index;
